var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#whatsapp_svg__a)",
    d: "M15.377 2.619A8.917 8.917 0 0 0 9.037 0C4.096 0 .071 4.005.071 8.92a8.91 8.91 0 0 0 1.194 4.455L0 18l4.749-1.242a9.002 9.002 0 0 0 4.287 1.089c4.939 0 8.964-4.005 8.964-8.919a8.84 8.84 0 0 0-2.623-6.309Zm-6.34 13.716c-1.34 0-2.651-.36-3.8-1.035l-.271-.162-2.822.738.75-2.736-.18-.279a7.41 7.41 0 0 1-1.14-3.942c0-4.086 3.347-7.416 7.453-7.416 1.99 0 3.862.774 5.264 2.178a7.362 7.362 0 0 1 2.18 5.247c.018 4.086-3.328 7.407-7.435 7.407Zm4.088-5.544c-.226-.108-1.33-.648-1.529-.729-.208-.072-.353-.108-.507.108-.153.225-.578.729-.705.873-.127.153-.262.171-.489.054-.226-.108-.95-.351-1.8-1.107-.669-.594-1.112-1.323-1.248-1.548-.126-.225-.018-.342.1-.459.1-.099.226-.261.334-.387.109-.126.154-.225.227-.369.072-.153.036-.279-.019-.387a73.825 73.825 0 0 1-.687-1.656c-.18-.432-.37-.378-.507-.387h-.434a.814.814 0 0 0-.597.279c-.199.225-.778.765-.778 1.863 0 1.098.805 2.16.914 2.304.109.153 1.583 2.403 3.826 3.366.534.234.95.369 1.275.468.534.171 1.023.144 1.412.09.434-.063 1.33-.54 1.51-1.062.19-.522.19-.963.127-1.062-.064-.099-.2-.144-.425-.252Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "whatsapp_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(54.409 -4.389 12.611) scale(9.06589 207.431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#F0CAB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC836D"
  })))));
};
export default SvgWhatsapp;